let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4oiyH")).then(() => parcelRequire('jt6zg'));